import React, { useEffect, useMemo, useState } from "react";
import {
  Grid,
  Typography,
  Divider,
  LinearProgress,
  styled,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setProdcuctName,
  setSelectedIndex,
} from "../../../services/redux/slices/tabsSlice";
import { setSelectedloanAccountNumber } from "../../../services/redux/slices/optionSlice";
import { setloanAccountNumberOptions } from "../../../services/redux/slices/optionSlice";
import { Box, useMediaQuery, useTheme } from "@mui/system";
import {
  formatIndianRupees,
  handlePercentAmount,
  checkPercentage,
} from "../../../utils/formatting";
import {
  setDashboardData,
  setExistDisbursementStatus,
  setSelectedLoanNumber,
} from "../../../services/redux/slices/dashboardDataSlice";
import { ROUTES } from "../../../routes/routerConfig";
import {
  authSelector,
  userLoanCatSelector,
} from "../../../services/redux/slices/authSlice";
import {
  setStatusPopup,
  statusPopupSelector,
} from "../../../services/redux/slices/statusPopupSlice";
import { messages } from "../../../data/constant";
import { termLoanPermissionCheck } from "../../../utils/helpers";
import { cleardisbursementButtonSlice } from "../../../services/redux/slices/disbursementButtonSlice";
import { encrypt } from "../../../utils/crypto";
import Card from "../../../components/ui/Card";
import { OutlinedSmallButton } from "../../../components/ui/Button";
import Skeleton from "@mui/material/Skeleton";
import LoaderBackdrop from "../../../components/ui/LoaderBackdrop";
import postsServices from "../../../services/api/service/postsService";
import { RootState } from "../../../services/redux/store";
import UtilizedIcon from "../../../assets/images/icons/utilized.png";
import AvailableIcon from "../../../assets/images/icons/available.png";
import Breadcrumbs from "../../../components/ui/Breadcrumbs";
import {
  formatDate,
  formatNumberToTwoDecimals,
} from "../../../utils/dateFormatUtils";
import InfoIcon from "../../../assets/images/icons/info.png";
import AccountSelectorDropDown from "../../../components/ui/AccountSelectorDropDown";
interface Payload {
  cif: any;
  business: any;
  loanCategory: any;
}

const ViewAllLoans = () => {
  const [TermLoanDashboardData, setTermLoanDashboardData] = useState<any[]>([]);
  const { userProfile, businessType } = useSelector(authSelector);
  const [isLoading, setIsLoading] = useState(true);
  const selectedIndex = useSelector(
    (state: RootState) => state?.tabs?.selectedIndex
  );
  const navigate = useNavigate();
  const { refreshValue } = useSelector(statusPopupSelector);
  const userLoanCategory = useSelector(userLoanCatSelector);
  const [selected, setSelected] = useState("termLoan");

  const handleChangeToggle = (event: any, newSelection: any) => {
    if (newSelection !== null) {
      setSelected(newSelection);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const payload: Payload = {
        cif: userProfile?.cifNumber,
        business: encrypt(businessType?.id),
        loanCategory: encrypt(userLoanCategory?.TermLoan[0]?.loanCategoryId),
      };
      try {
        const response = await postsServices.addPost(
          "api/v1/dashboard/term-loan-dashboard",
          payload
        );
        setTermLoanDashboardData(response?.data?.data);
      } catch (error: any) {
        // const errorMessage =
        //   error.response?.data?.message ||
        //   messages.withdrErrorMessages.commonError;
        // console.error("Error fetching data:", errorMessage);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [refreshValue, userProfile?.cifNumber]);

  const dispatch = useDispatch();

  const handleViewDetailsClick = (
    loanAccountNumber: any,
    isExistDisbursementAllowdLoan: any
  ) => {
    if (termLoanPermissionCheck()) {
      let filterLoanAccountNumber = TermLoanDashboardData?.map(
        (acc) => acc.lanNumber
      );
      dispatch(setloanAccountNumberOptions(filterLoanAccountNumber));
      //dispatch(setSelectedloanAccountNumber(loanAccountNumber));
      dispatch(setDashboardData(TermLoanDashboardData));
      dispatch(setExistDisbursementStatus(isExistDisbursementAllowdLoan));
      //dispatch(setSelectedLoanNumber(loanAccountNumber));
      navigate(ROUTES?.Dashboard?.termLoanPage?.locationPath);
      dispatch(setSelectedIndex(0));
      dispatch(setProdcuctName("TermLoan"));
    } else {
      dispatch(
        setStatusPopup({
          status: "no access",
          message: `${messages.noPermission.module} "Account Summary"`,
        })
      );
    }
  };

  const sortedTermLoanData = useMemo(() => {
    return TermLoanDashboardData
      ? TermLoanDashboardData.sort((a: any, b: any) =>
          a.statusOfLoan === "A" ? -1 : b.statusOfLoan === "A" ? 1 : 0
        )
      : [];
  }, [TermLoanDashboardData]);

  const dashboardDataSet = useSelector(
    (state: RootState) => state.dashboardData.existMoratStatus
  );

  const requestForDisbursement = (
    loanAccountNumber: any,
    isExistDisbursementAllowdLoan: any
  ) => {
    if (termLoanPermissionCheck()) {
      let filterLoanAccountNumber = TermLoanDashboardData?.map(
        (acc: any) => acc.lanNumber
      );
      dispatch(cleardisbursementButtonSlice());
      dispatch(setloanAccountNumberOptions(filterLoanAccountNumber));
      // dispatch(setSelectedloanAccountNumber(loanAccountNumber));
      dispatch(setDashboardData(TermLoanDashboardData));
      dispatch(setSelectedLoanNumber(loanAccountNumber));
      navigate(ROUTES?.Dashboard?.termLoanPage?.locationPath);
      dispatch(setSelectedIndex(0));
      dispatch(setProdcuctName("TermLoan"));
    } else {
      dispatch(
        setStatusPopup({
          status: "no access",
          message: `${messages.noPermission.module} "Account Summary"`,
        })
      );
    }
  };

  let spacing = 4;
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  if (isXsOrSm) {
    spacing = 0;
  }
  const MultiColorProgressBar = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    backgroundColor: "rgba(22, 135, 148, 1)",
    "& .MuiLinearProgress-bar": {
      backgroundColor: "rgba(254, 193, 13, 1)",
    },
  }));
  const MultiColorProgressBarMobile = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: "5px",
    backgroundColor: "rgba(22, 135, 148, 1)", // Available background
    "& .MuiLinearProgress-bar": {
      backgroundColor: "rgba(254, 193, 13, 1)", // Utilized color
    },
  }));
  const LoanCardSkeleton = () => (
    <Box sx={{ padding: "20px", marginBottom: "20px" }}>
      <Grid container>
        <Grid item xs={12} sm={8}>
          <Skeleton variant="rectangular" width="100%" height={30} />
          <Skeleton variant="rectangular" width="70%" height={20} />
        </Grid>
        <Grid
          item
          xs={12}
          sm={4}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Skeleton variant="rectangular" width={120} height={35} />
        </Grid>
      </Grid>
      <Divider sx={{ margin: "20px 0" }} />
      <Grid container spacing={2}>
        {[...Array(6)].map((_, index) => (
          <Grid item xs={12} sm={4} key={index}>
            <Skeleton variant="rectangular" width="100%" height={20} />
            <Skeleton variant="rectangular" width="80%" height={15} />
          </Grid>
        ))}
      </Grid>
      <Divider sx={{ margin: "20px 0" }} />
      <Grid container>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="rectangular" width="100%" height={20} />
          <Skeleton variant="rectangular" width="80%" height={15} />
          <Skeleton variant="rectangular" width="60%" height={10} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="rectangular" width="100%" height={20} />
          <Skeleton variant="rectangular" width="80%" height={15} />
          <Skeleton variant="rectangular" width="60%" height={10} />
        </Grid>
      </Grid>
      <Skeleton
        variant="rectangular"
        width="100%"
        height={10}
        sx={{ marginTop: "10px" }}
      />
    </Box>
  );

  let breadcrumbItems = [
    { label: "Dashboard", path: "/" },
    { label: "Loans" }, // Current page, no `path` needed
  ];

  return (
    <React.Fragment>
      <Grid container>
        {isLoading ? (
          <>
            {[1, 2, 3, 4, 5].map((item, index) => (
              <Card key={index}>
                <LoanCardSkeleton />
              </Card>
            ))}
          </>
        ) : (
          <>
            <Box sx={{ padding: "0px 0px 18px 0px" }}>
              {isXsOrSm ? (
                <>
                  <Typography
                    sx={{
                      fontWeight: "700",
                      fontSize: "14px",
                      letterSpacing: "1px",
                      color: "#168794",
                      paddingTop: "15px",
                    }}
                  >
                    All Loans
                  </Typography>
                </>
              ) : (
                <Breadcrumbs items={breadcrumbItems} />
              )}
            </Box>

            {sortedTermLoanData.map((item, index) => (
              <Card key={index} marginBottom="20px">
                {!isXsOrSm && (
                  <>
                    <Grid container sm className="active-button-container">
                      <Grid item sm={8} sx={{ height: "28px" }}>
                        <Typography className="loan-account-main-heading">
                          Loan A/c {item?.lanNumber}
                          <Typography
                            className="active-button"
                            style={{
                              color:
                                item?.statusOfLoan === "A"
                                  ? "#28C76F"
                                  : "#EA5455",
                              backgroundColor:
                                item?.statusOfLoan === "A"
                                  ? "#28C76F29"
                                  : "#EA545529",
                            }}
                          >
                            {item?.statusOfLoan === "A" ? "Active" : "Closed "}
                          </Typography>
                        </Typography>
                        <Typography className="loan-account-sub-heading">
                          {item?.description}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        sm={4}
                        sx={{
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "right",
                        }}
                      >
                        <OutlinedSmallButton
                          title={"View Details"}
                          click={() =>
                            requestForDisbursement(
                              item?.lanNumber,
                              item?.isExistDisbursementAllowdLoan
                            )
                          }
                        />
                      </Grid>
                    </Grid>

                    <Grid container sm sx={{ paddingTop: "30px" }}>
                      <Grid item sm={12}>
                        <Divider
                          sx={{
                            border: isXsOrSm
                              ? ""
                              : "1px solid rgba(219, 218, 222, 1)",
                            borderColor: isXsOrSm ? "rgba(0, 0, 0, 0.12)" : "",
                            borderBottomWidth: isXsOrSm ? "thin" : "",
                            width: "100%",
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container sm className="dashboard-container mt-20">
                      <Grid item xs={12} sm={7} md={7} lg={7}>
                        <Grid container spacing={spacing}>
                          <Grid item xs={4} sm={4} md={4} lg={4}>
                            <Typography className="insidePageLable">
                              Loan Amount
                            </Typography>
                            <Typography
                              variant="subtitle1"
                              className="insidePageValue"
                            >
                              {formatIndianRupees(item?.loanAmount)}
                            </Typography>
                          </Grid>
                          <Grid item xs={4} sm={4} md={4} lg={4}>
                            <Typography
                              className="insidePageLable"
                              style={{ marginTop: "2px" }}
                            >
                              ROI
                              {item?.morat && (
                                <Tooltip
                                  placement="top"
                                  title={"ROI post Moratorium"}
                                  enterTouchDelay={50}
                                >
                                  <img
                                    src={InfoIcon}
                                    alt="Status"
                                    className="imgicon"
                                  />
                                </Tooltip>
                              )}
                            </Typography>

                            <Typography
                              variant="subtitle1"
                              className="insidePageValue"
                              style={{ marginTop: "-4px" }}
                            >
                              {formatNumberToTwoDecimals(
                                item?.outstandingPrincipal
                              )}{" "}
                              %
                            </Typography>
                          </Grid>
                          <Grid item xs={4} sm={4} md={4} lg={4}>
                            <Typography className="insidePageLable">
                              Next Repay Amount
                            </Typography>
                            <Typography
                              variant="subtitle1"
                              className="insidePageValue"
                            >
                              {formatIndianRupees(item.emiAmount)}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={spacing}>
                          <Grid item xs={4} sm={4} md={4} lg={4}>
                            <Typography className="insidePageLable">
                              Next Repay Date
                            </Typography>
                            <Typography
                              variant="subtitle1"
                              className="insidePageValue"
                            >
                              {formatDate(item?.nextEmiDate)}
                            </Typography>
                          </Grid>
                          <Grid item xs={4} sm={4} md={4} lg={4}>
                            <Typography className="insidePageLable">
                              Loan Tenure (Months)
                            </Typography>
                            <Typography
                              variant="subtitle1"
                              className="insidePageValue"
                            >
                              {item?.loanTenure}
                            </Typography>
                          </Grid>
                          <Grid item xs={4} sm={4} md={4} lg={4}>
                            <Typography className="insidePageLable">
                              Loan Start Date
                            </Typography>
                            <Typography
                              variant="subtitle1"
                              className="insidePageValue"
                            >
                              {formatDate(item?.firstDisbDate)}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={12} sm={5} md={5} lg={5}>
                        <div style={{ display: "flex" }}>
                          {!isXsOrSm && (
                            <div className="line-container">
                              <div className="line vertical"></div>

                              <div className="line vertical"></div>
                            </div>
                          )}
                          <Grid container sm className="muiLinearProgress">
                            {/* Utilised Section */}
                            <Grid
                              item
                              xs={6}
                              sm={6}
                              md={6}
                              lg={6}
                              className="right-border"
                            >
                              <Typography className="mainHeadingLable muiLinear-progress-p">
                                <img
                                  src={UtilizedIcon}
                                  alt="Available"
                                  style={{
                                    height: "22px",
                                  }}
                                />
                                <span className="left-side-span">
                                  Disbursed Amount
                                </span>
                              </Typography>
                              <Typography className="mainHeadingValue">
                                {formatIndianRupees(item?.loanAmount)}
                              </Typography>
                              {/* Calculate and display the dynamic percentage */}
                              <Typography className="mainHeadingPerValue">
                                {handlePercentAmount(
                                  item?.loanAmount,
                                  item?.repayAmount,
                                  "disburse"
                                )}
                                % used
                              </Typography>
                            </Grid>

                            {/* Available Section */}
                            <Grid
                              item
                              xs={6}
                              sm={6}
                              md={6}
                              lg={6}
                              sx={{
                                marginLeft: "auto",
                                textAlign: "right",
                              }}
                            >
                              <Typography className="mainHeadingLable text-align-right">
                                <span className="right-side-span">
                                  Sanctioned Amount
                                </span>
                                <img
                                  src={AvailableIcon}
                                  alt="Available"
                                  style={{
                                    height: "22px",
                                  }}
                                />
                              </Typography>

                              <div className="muiLinear-progress-div">
                                <Typography className="mainHeadingValue text-align-right mainHeadingValueRight">
                                  {formatIndianRupees(item?.repayAmount)}
                                </Typography>
                                {/* Calculate and display the dynamic percentage */}
                                <Typography className="mainHeadingPerValue text-align-right">
                                  {handlePercentAmount(
                                    item?.loanAmount,
                                    item?.repayAmount,
                                    "sanction"
                                  )}
                                  % left
                                </Typography>
                              </div>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12}>
                              <Box sx={{ width: "100%", marginTop: 3 }}>
                                <MultiColorProgressBar
                                  variant="determinate"
                                  value={parseInt(checkPercentage(item))} // Dynamic percentage
                                />
                              </Box>
                            </Grid>
                          </Grid>
                        </div>
                      </Grid>
                    </Grid>
                  </>
                )}
                {isXsOrSm && (
                  <>
                    <Grid container className="active-button-container">
                      <Grid container mt={1}>
                        <Grid item xs={9} sm={9} md={8} lg={8}>
                          <Typography className="loan-account-main-heading">
                            Loan A/c {item?.lanNumber}
                          </Typography>
                          <Typography className="loan-account-sub-heading-2">
                            {item?.description}
                          </Typography>
                        </Grid>
                        <Grid item xs={3} sm={3} md={4} lg={4}>
                          <Typography
                            className="active-button-mobile"
                            style={{
                              color:
                                item?.statusOfLoan === "A"
                                  ? "#28C76F"
                                  : "#EA5455",
                              backgroundColor:
                                item?.statusOfLoan === "A"
                                  ? "#28C76F29"
                                  : "#EA545529",
                            }}
                          >
                            {item?.statusOfLoan === "A" ? "Active" : "Closed "}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Divider
                        sx={{
                          border: isXsOrSm
                            ? ""
                            : "1px solid rgba(219, 218, 222, 1)",
                          borderColor: isXsOrSm ? "rgba(0, 0, 0, 0.12)" : "",
                          borderBottomWidth: isXsOrSm ? "thin" : "",
                          width: "100%",
                          marginTop: "6px",
                        }}
                      />
                    </Grid>
                    <Grid container sm className="mt-20">
                      <Grid item xs={12} sm={5} md={5} lg={5} className="mb-20">
                        <div style={{ display: "flex" }}>
                          {!isXsOrSm && (
                            <div className="line-container">
                              <div className="line vertical"></div>
                              <div className="line vertical"></div>
                            </div>
                          )}
                          <Grid container sm className="muiLinearProgress">
                            {/* Utilised Section */}
                            <Grid
                              item
                              xs={6}
                              sm={6}
                              md={6}
                              lg={6}
                              className="right-border"
                            >
                              <Typography className="mainHeadingLable muiLinear-progress-p">
                                <img
                                  src={UtilizedIcon}
                                  alt="Available"
                                  style={{
                                    height: "22px",
                                  }}
                                />
                                <span className="left-side-span">
                                  Disbursed Amount
                                </span>
                              </Typography>
                              <Typography className="mainHeadingValueMobile">
                                {formatIndianRupees(item?.loanAmount)}
                              </Typography>
                              {/* Calculate and display the dynamic percentage */}
                              <Typography className="mainHeadingPerValueMobile">
                                {handlePercentAmount(
                                  item?.loanAmount,
                                  item?.repayAmount,
                                  "disburse"
                                )}
                                % used
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                              <Typography className="mainHeadingLable  text-align-right">
                                <span className="right-side-span">
                                  Sanctioned Amount
                                </span>
                                <img
                                  src={AvailableIcon}
                                  alt="Available"
                                  style={{
                                    height: "22px",
                                  }}
                                />
                              </Typography>
                              <Typography className="mainHeadingValueMobile text-align-right mainHeadingValueMobileRight">
                                {formatIndianRupees(item?.repayAmount)}
                              </Typography>
                              {/* Calculate and display the dynamic percentage */}
                              <Typography className="mainHeadingPerValueMobile text-align-right">
                                {handlePercentAmount(
                                  item?.loanAmount,
                                  item?.repayAmount,
                                  "sanction"
                                )}
                                % left
                              </Typography>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12}>
                              <Box sx={{ width: "100%", marginTop: 1 }}>
                                <MultiColorProgressBarMobile
                                  variant="determinate"
                                  value={parseInt(checkPercentage(item))} // Dynamic percentage
                                />
                              </Box>
                            </Grid>
                          </Grid>
                        </div>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={7}
                        md={7}
                        lg={7}
                        className="dashboard-container-mobile"
                      >
                        <Grid container spacing={spacing}>
                          <Grid item xs={4} sm={4} md={4} lg={4}>
                            <Typography className="insidePageLableMobile">
                              Loan Amount
                            </Typography>
                            <Typography
                              variant="subtitle1"
                              className="insidePageValueMobile"
                            >
                              {formatIndianRupees(item?.loanAmount)}
                            </Typography>
                          </Grid>
                          <Grid item xs={4} sm={4} md={4} lg={4}>
                            <Typography
                              className="insidePageLableMobile"
                              style={{ marginTop: "2px" }}
                            >
                              ROI
                              {item.morat && (
                                <Tooltip
                                  placement="top"
                                  title={"ROI post Moratorium"}
                                  enterTouchDelay={50}
                                >
                                  <img
                                    src={InfoIcon}
                                    alt="Status"
                                    className="imgicon"
                                  />
                                </Tooltip>
                              )}
                            </Typography>
                            <Typography
                              variant="subtitle1"
                              className="insidePageValueMobile"
                            >
                              {formatNumberToTwoDecimals(
                                item?.outstandingPrincipal
                              )}{" "}
                              %
                            </Typography>
                          </Grid>
                          <Grid item xs={4} sm={4} md={4} lg={4}>
                            <Typography className="insidePageLableMobile">
                              Next Repay Amount
                            </Typography>
                            <Typography
                              variant="subtitle1"
                              className="insidePageValueMobile"
                            >
                              {formatIndianRupees(item?.emiAmount)}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={spacing} mt={1}>
                          <Grid item xs={4} sm={4} md={4} lg={4}>
                            <Typography className="insidePageLableMobile">
                              Next Repay Date
                            </Typography>
                            <Typography
                              variant="subtitle1"
                              className="insidePageValueMobile"
                            >
                              {formatDate(item?.nextEmiDate)}
                            </Typography>
                          </Grid>
                          <Grid item xs={4} sm={4} md={4} lg={4}>
                            <Typography className="insidePageLableMobile">
                              Loan Tenure (Months)
                            </Typography>
                            <Typography
                              variant="subtitle1"
                              className="insidePageValueMobile"
                            >
                              {item?.loanTenure}
                            </Typography>
                          </Grid>
                          <Grid item xs={4} sm={4} md={4} lg={4}>
                            <Typography className="insidePageLableMobile">
                              Loan Start Date
                            </Typography>
                            <Typography
                              variant="subtitle1"
                              className="insidePageValueMobile"
                            >
                              {formatDate(item?.firstDisbDate)}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid container sm className="mt-20 mb-20">
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          sx={{
                            display: "flex",
                            justifyContent: "right",
                            alignItems: "right",
                          }}
                        >
                          <Box sx={{ float: "right" }}>
                            <OutlinedSmallButton
                              title={"View Details"}
                              click={() =>
                                requestForDisbursement(
                                  item?.lanNumber,
                                  item?.isExistDisbursementAllowdLoan
                                )
                              }
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  </>
                )}
              </Card>
            ))}
          </>
        )}
      </Grid>
    </React.Fragment>
  );
};

export default ViewAllLoans;
